import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initSodium } from "@/lib/crypto";
import "@/lib/i18n";
import "./index.css";

// libsodium's WASM must finish loading before any encrypt/decrypt call anywhere
// in the app, so this is awaited before the first render.
initSodium().then(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
